import { FiX } from "react-icons/fi";

const SIZE_CLASS = {
  sm: "w-[min(94vw,24rem)] max-w-md",
  md: "w-[min(94vw,36rem)] max-w-2xl",
  lg: "w-[min(94vw,52rem)] max-w-4xl",
};

function ModalBackdrop({ onClose }) {
  return (
    <form method="dialog" className="modal-backdrop">
      <button type="button" onClick={onClose} aria-label="Close modal">
        close
      </button>
    </form>
  );
}

export function AppModal({ open, onClose, title, subtitle, size = "md", children }) {
  if (!open) return null;

  return (
    <dialog open className="modal modal-open">
      <div className={`ui-app-modal-box ${SIZE_CLASS[size] || SIZE_CLASS.md}`}>
        <header className="ui-app-modal-header">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0 flex-1">
              {title ? <h3 className="ui-app-modal-title">{title}</h3> : null}
              {subtitle ? <p className="ui-app-modal-subtitle">{subtitle}</p> : null}
            </div>
            <button
              type="button"
              className="btn btn-ghost btn-xs btn-square h-7 min-h-7 w-7 shrink-0 rounded-md text-base-content/60 hover:text-base-content"
              onClick={onClose}
              aria-label="Close"
            >
              <FiX className="size-3.5" aria-hidden />
            </button>
          </div>
        </header>
        {children}
      </div>
      <ModalBackdrop onClose={onClose} />
    </dialog>
  );
}

export function AppModalBody({ children, className = "" }) {
  return <div className={`ui-app-modal-body ${className}`.trim()}>{children}</div>;
}

export function AppModalFooter({ children }) {
  return (
    <footer className="ui-app-modal-footer">
      <div className="modal-action mt-0 justify-end gap-2">{children}</div>
    </footer>
  );
}
